module.exports = __webpack_public_path__ + "static/media/logo_tr.89fa97ef.png";